module.exports = new __parcel__URL__("stone-brick.1f3f8e2a.webp").toString();